<template>
  <div class="mh bg-main success">
    <!-- 背景图片 -->
    <img src="../../assets/img/cuo.png" alt="" class="successIcon" v-if="type==3 || type==5 || type==6 || type==7 || type==8"/>
    <img src="../../assets/img/chenggong@2x.png" alt="" class="successIcon" v-else/>
    <div class="successTip" v-if="type==1">登录成功</div>
    <div class="successTip" v-if="type==2">提交报名成功</div>
    <div class="successTip" v-if="type==3">登录失败，微信未绑定,请登录后绑定再尝试扫码登录</div>
    <div class="successTip" v-if="type==4">绑定成功</div>
    <div class="successTip" v-if="type==5">绑定失败</div>
    <div class="successTip" v-if="type==6">绑定失败，账号已被绑定，请先解除绑定</div>
    <div class="successTip" v-if="type==7">登录失败，二维码已过期</div>
    <div class="successTip" v-if="type==8">绑定失败，账号未登录</div>
    <div class="confirmBtn" v-if="type" @click="closeWx">确定</div>
  </div>
</template>

<script>
import * as wx from "@/common/jweixin";
export default {
  name: "index",
  data() {
    return {
      type: ''
    };
  },
  components: {},
  created() {
    this.type = this.$route.query.type
    
    localStorage.clear()
    if(this.type == 1) {
      document.title = '微信绑定成功'
    }
  },
  methods:{
    closeWx() {
      wx.closeWindow()
    }
  }

};
</script>

<style scoped>
.success {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding-top: 200px;
  align-items: center;
  background-color: #fff;
}
.successTip {
  font-weight: bold;
}
.desc {
  margin-top: 10px;
}
.successIcon {
  width: 100px;
  margin-bottom: 20px;
}
.confirmBtn {
  margin-top: 150px;
  width: 150px;
  text-align: center;
  border: 2px solid #dcdfe6;
  line-height: 40px;
  font-weight: bold;
  color: #606266;
  border-radius: 30px;

}
</style>